enum WALLET_TABS {
  TRADING = 'trading',
  TRADING_CREDITS = 'trading_credits',
  DELTA_CASH = 'delta_cash',
  INVEST = 'invest',
}

export { WALLET_TABS };
